import { render, staticRenderFns } from "./ChannelSelectionStep.vue?vue&type=template&id=38d7b0fc&scoped=true"
import script from "./ChannelSelectionStep.vue?vue&type=script&lang=js"
export * from "./ChannelSelectionStep.vue?vue&type=script&lang=js"
import style0 from "./ChannelSelectionStep.vue?vue&type=style&index=0&id=38d7b0fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7b0fc",
  null
  
)

export default component.exports